module.exports = __webpack_public_path__ + "img/default-star-empty-icon.13cb69c8.svg";